import React from "react";
import { Link } from "react-router-dom";
import HamburgerBtn from "../../../../../atoms/button/HamburgerBtn";
import { MOBILE_LOGO_PROPS } from "../constants/mobileNavigation";

interface MobileNavBarHeaderProps {
  logoProps?: { src?: string; alt?: string };
  isMenuOpen: boolean;
  onMenuToggle: () => void;
}

const MobileNavBarHeader: React.FC<MobileNavBarHeaderProps> = ({
  logoProps,
  isMenuOpen,
  onMenuToggle,
}) => {
  const src = logoProps?.src ?? MOBILE_LOGO_PROPS.src;
  const alt = logoProps?.alt ?? MOBILE_LOGO_PROPS.alt;

  return (
    <div className="relative z-50 flex h-[75px] min-h-[75px] w-[90%] flex-row items-center justify-between rounded-[20px] border-[1.5px] border-muted bg-white px-3">
      <div className="flex h-full w-1/2 items-center justify-start">
        <Link to="/" className="block cursor-pointer">
          <img src={src} alt={alt} className="h-11 w-auto object-contain" />
        </Link>
      </div>

      <div className="flex h-full w-1/2 items-center justify-end">
        <HamburgerBtn isOpen={isMenuOpen} toggle={onMenuToggle} />
      </div>
    </div>
  );
};

export default MobileNavBarHeader;
